import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(document).ready(function(){
    let viewH = $(window).height();
    let viewW = $(window).width();
    countTime();
    
    //显示隐藏表单
    $('.section3 .text .common-link').on('click',function(){
        $('.section3 .img').addClass('active')
    })
    $('.section3 .img .close').on('click',function(){
        $('.section3 .img').removeClass('active')
    })

    // 产品切换
    var swiper2 = new Swiper(".section5 .right .mySwiper", {
        effect : 'fade',
        speed: 600,
        slidesPerView : 1,
        allowTouchMove: false,
        // direction: 'vertical',
        // touchStartPreventDefault:false,
        on:{
            init: function(swiper){
                $(".section5 .left .icon-tab .icon").eq(this.realIndex).addClass('active')
                protrans(this.realIndex)
            },
            slideChangeTransitionStart: function(){
                $(".section5 .left .icon-tab .icon").eq(this.realIndex).addClass('active').siblings().removeClass('active')
                protrans(this.realIndex)
                if(viewW <= 992){
                    $(".section5 .right").css('transform','translateY('+ this.realIndex*0 +'rem)')
                }
            },
        }
    })
    $(".section5 .left .icon-tab .icon").hover(function(){
        let index = $(this).index()
        swiper2.slideTo(index)
    })

    //swiper
    var swiper1 = new Swiper(".section6 .mySwiper", {
        speed: 600,
        slidesPerView : 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        touchStartPreventDefault:false,
        breakpoints: { //响应式
            768: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 1.5,
                slidesPerGroup: 1,
                spaceBetween: 20
            },
            1280: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20
            }
        },
        navigation: {//按钮
            nextEl: ".section6 .swiper-button-next",
            prevEl: ".section6 .swiper-button-prev",
        },
    })

    $(".section6 .mySwiper .swiper-slide .number .total").html(setNum($(".section6 .mySwiper .swiper-slide").length))
    $(".section6 .mySwiper .swiper-slide .number .now")
    for(let i=0; i<$(".section6 .mySwiper .swiper-slide .number .now").length; i++){
        $(".section6 .mySwiper .swiper-slide .number .now").eq(i).html(setNum($(".section6 .mySwiper .swiper-slide").eq(i).index()+1))
    }

    // 滚动到表单部分
    $('.section8 .common-link').on('click',function(){
        let scrTop = 0
        if(viewW > 1024){
            scrTop = $('.section3').offset().top
        }else{
            scrTop = $('.section3 .img').offset().top - viewH/20
        }

        if(!$('.section3 .img').hasClass('active')){
            $('.section3 .img').addClass('active')
        }

        $("html, body").animate({
            scrollTop: scrTop
        }, {duration: 500,easing: "swing"});
    })
    // 表单button提交
    // $('.section3 form').on('submit', function(event) {  
    //     event.preventDefault(); // 阻止表单默认提交行为  
    //     $('.section3 .img .close').hide();
    //     $('.mask-form').fadeIn(200); // 显示遮罩层  
    //     $('.form-success').fadeIn(260); // 显示弹出框  
    // });  

    $('.form-success .iconfont').on('click', function() {  
        // 点击图标时刷新页面  
        location.reload();  
    });
})

let rotate = 0
let beforeScroH = $(document).scrollTop();
$(window).scroll(function () {
    let scroH = $(document).scrollTop();
    let viewH = $(window).height();
    let viewW = $(window).width();
    
    // 滚动页面，播放视频
    if($('.section1 video').length > 0){
        $('.section1').find('video')[0].play()
    }
    $('.section3').find('video')[0].play()

    // 滚动，视频放大
    let sec3Top = $('.section3').offset().top
    let sec3Btm = $('.section3').offset().top + $('.section3').outerHeight() - viewH
    if(viewW > 1024){
        if (scroH <= sec3Top) {
            $('.section3 .fixed-cont').removeClass('fixed')
        }else if (scroH > sec3Top && scroH < sec3Btm) {
            $('.section3 .fixed-cont').addClass('fixed').removeClass('abs')
        }else{
            $('.section3 .fixed-cont').addClass('abs').removeClass('fixed')
        }

        if(scroH > sec3Top + viewH*.1){
            $('.section3 .fixed-cont').addClass('active')
        }else{
            $('.section3 .fixed-cont').removeClass('active')
        }
    }

    // 左侧社媒颜色更改
    let socialH = $('.fixed-social').outerHeight()

    let white1Top = $('.section3').offset().top - viewH + socialH/2
    let blue1Top
    if(viewW > 1024){
        // blue1Top = $('.section4').offset().top - viewH + socialH/2 + viewH*0.8
        blue1Top = $('.section3').offset().top + viewH*0.1
    }else{
        blue1Top = $('.section3 .video').offset().top - viewH + socialH/2
    }
    let white2Top = $('.section6').offset().top - viewH + socialH/2
    let blue2Top = $('.section7').offset().top - viewH + socialH/2

    if(scroH < white1Top){
        $('.fixed-social').removeClass('blue')
    }else if(scroH >= white1Top && scroH < blue1Top){
        $('.fixed-social').addClass('blue')
    }else if(scroH >= blue1Top && scroH < white2Top){
        $('.fixed-social').removeClass('blue')
    }else if(scroH >= white2Top && scroH < blue2Top){
        $('.fixed-social').addClass('blue')
    }else if(scroH >= blue2Top){
        $('.fixed-social').removeClass('blue')
    }

    //轮胎滚动
    let sec8Top = $('.section8').offset().top - viewH
    //判断页面是上滚还是下滚
    let delta = scroH - beforeScroH;
    
    if(scroH > sec8Top){
        if (delta > 0) {
            rotate += 1
            $('.section8 .cont .img').removeClass('reverse')
        }
        if (delta < 0) {
            rotate -= 1
            $('.section8 .cont .img').addClass('reverse')
        }
    }else{
        rotate = 0
    }
    $('.section8 .img>div').css('transform','rotate('+ rotate +'deg)')

    beforeScroH = scroH;
});

// 产品
function protrans(index){
    let length = $(".section5 .left .icon-tab .icon").length
    let transEl = $(".section5 .right .trans-cont")

    for(let i=0; i<length; i++){
        let num = index - i
        if(index >= i){
            let scale = 1-num*0.03
            $(transEl[i]).addClass('active')
            $(transEl[i]).find('.item').css('transform','scale('+ scale +') translateY(-'+ num*0 +'rem)')
        }else{
            $(transEl[i]).removeClass('active')
            $(transEl[i]).find('.item').css('transform','scale(1) translateY(0%)')
            $(transEl[i]).find('.mask').css('opacity', '0')
        }
        let bgCont = $(transEl[i]).find('.bg-cont');
        if (i === index) {  
            bgCont.stop(true, true).fadeTo(600, 1).css('display', 'block'); // 当前索引设置透明度为 1，并确保显示  
        } else {  
            bgCont.stop(true, true).fadeTo(600, 0, function() {  
                $(this).css('display', 'none'); // 透明度为 0 后隐藏  
            });  
        } 
    }
}


// 倒计时
function countTime() {
    //获取当前时间  
    var date = new Date();  
    var now = date.getTime();  
    //设置截止时间  
    var str="2025/4/7 00:00:00";
    var endDate = new Date(str); 
    var end = endDate.getTime();  
    
    //时间差  
    var leftTime = end-now; 
    // console.log(leftTime);
    // 634671375  86400000
    //定义变量 d,h,m,s保存倒计时的时间  
    var d,h,m,s;  
    if (leftTime>=0) {  
        d = Math.floor(leftTime/1000/60/60/24);  
        h = Math.floor(leftTime/1000/60/60%24);  
        m = Math.floor(leftTime/1000/60%60);  
        s = Math.floor(leftTime/1000%60); 
        //将倒计时赋值到div中
        $('#day').html(d)
        $('#hours').html(h)
        $('#mins').html(m)
        $('#secs').html(s)  
        //递归每秒调用countTime方法，显示动态时间效果  
        setTimeout(countTime,1000);                    
    } else{
        // $(".timer").addClass("hidden");
    }
}

function setNum(num){
    if(Number(num) >= 10){
        return num
    }else{
        return '0'+num
    }
}